import { isCountrySpain } from 'utilities/multiLanguageHelper';

export const getNationalityCountries = ({ listCountries, isRegisteringWithMainDocumentType }) => {
    if (isCountrySpain()) {
        return listCountries.filter(
            country => isRegisteringWithMainDocumentType || __ORIGIN_COUNTRY__ !== country.value
        );
    }

    return listCountries;
};
